var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxCleanup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-inbox-cleanup:not(.animated) .animable {opacity: 0;}svg#freepik_stories-inbox-cleanup.animated #freepik--Device--inject-5 {animation: 1.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-inbox-cleanup.animated #freepik--trash-can--inject-5 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-hidden",
    style: {
      transformOrigin: "251.12px 333.69px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 251.12,
    cy: 333.69,
    rx: 238.53,
    ry: 140.13,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "251.12px 333.69px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-hidden",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "247.232px 312.245px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m35.08 343.63 112.6 65a10.25 10.25 0 0 0 9.28 0l212.04-122.41c2.56-1.48 2.56-3.88 0-5.36l-112.6-65a10.25 10.25 0 0 0-9.28 0l-212 122.42c-2.6 1.47-2.6 3.87-0.04 5.35z",
    style: {
      transformOrigin: "202.042px 312.245px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "c",
    className: "animable",
    cx: 423.78,
    cy: 358.9,
    rx: 37.52,
    ry: 21.66,
    style: {
      transformOrigin: "423.78px 358.9px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 319.05,
    cy: 373.47,
    rx: 55.81,
    ry: 32.22,
    style: {
      transformOrigin: "319.05px 373.47px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "199.53px 302.417px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "199.53px 302.417px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "199.53px 302.417px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M42.6,321.2c-1.57,1.22-1.4,3,.51,4.06L148,385.8a8.5,8.5,0,0,0,7.63,0L355.94,270.11c1.94-1.12,2.1-2.88.45-4.1a8.5,8.5,0,0,1,3.36,6.31v5A8.41,8.41,0,0,1,356,284L155.59,399.64a8.41,8.41,0,0,1-7.63,0L43.12,339.12a8.38,8.38,0,0,1-3.81-6.61l0-5.05A8.53,8.53,0,0,1,42.6,321.2Z",
    fill: "#263238",
    style: {
      transformOrigin: "199.53px 333.283px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M43.11,325.26,148,385.8a8.5,8.5,0,0,0,7.63,0L355.94,270.11c2.1-1.21,2.11-3.19,0-4.4L251.1,205.18a8.47,8.47,0,0,0-7.63,0L43.11,320.86C41,322.08,41,324.05,43.11,325.26ZM227.35,220.83c1.8-1,3.68-.44,5.48.61l95.33,55c1.8,1,1.81,2.73,0,3.77l-156,90.07a7.28,7.28,0,0,1-6.54,0L70.3,315.27c-1.81-1-1.81-2.73,0-3.77Z",
    fill: "#455a64",
    style: {
      transformOrigin: "199.523px 295.488px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M356.39,266a8.5,8.5,0,0,1,3.36,6.31v5A8.43,8.43,0,0,1,356,284L155.59,399.64a7.91,7.91,0,0,1-3.82.92V386.7a7.87,7.87,0,0,0,3.82-.91L355.94,270.11C357.88,269,358,267.23,356.39,266Z",
    fill: "#37474f",
    style: {
      transformOrigin: "255.76px 333.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m293.46 241.39c-1.41-0.82-1.41-2.14 0-2.95a5.64 5.64 0 0 1 5.12 0c1.41 0.81 1.41 2.13 0 2.95a5.7 5.7 0 0 1-5.12 0z",
    style: {
      transformOrigin: "296.02px 239.911px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m105.44 354a12.81 12.81 0 0 1-6.27-1.5c-1.77-1-2.74-2.41-2.74-3.9s1-2.89 2.74-3.91a13.85 13.85 0 0 1 12.54 0c1.77 1 2.74 2.41 2.74 3.91s-1 2.88-2.74 3.9a12.81 12.81 0 0 1-6.27 1.5zm0-9.82a11.89 11.89 0 0 0-5.77 1.37c-1.45 0.84-2.24 1.92-2.24 3.05s0.79 2.2 2.24 3a12.78 12.78 0 0 0 11.54 0c1.44-0.84 2.24-1.92 2.24-3s-0.8-2.21-2.24-3.05a11.89 11.89 0 0 0-5.77-1.35z",
    fill: "#e6e6e6",
    style: {
      transformOrigin: "105.44px 348.596px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296,251.18l-19.74-11.39c-1.17-.68-1.23-1.75-.13-2.39a4.56,4.56,0,0,1,4.13.08L300,248.87c1.18.68,1.23,1.75.13,2.39A4.56,4.56,0,0,1,296,251.18Z",
    style: {
      transformOrigin: "288.132px 244.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M227.35,220.83c1.8-1,3.68-.44,5.48.61l95.33,55c1.8,1,1.81,2.73,0,3.77l-156,90.07a7.28,7.28,0,0,1-6.54,0L70.3,315.27c-1.81-1-1.81-2.73,0-3.77Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "199.228px 295.681px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M227.35,220.83c1.8-1,3.68-.44,5.48.61l95.33,55c1.8,1,1.81,2.73,0,3.77l-156,90.07a7.28,7.28,0,0,1-6.54,0L70.3,315.27c-1.81-1-1.81-2.73,0-3.77Z",
    fill: "#fff",
    opacity: 0.8,
    style: {
      transformOrigin: "199.228px 295.681px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "85.9769px 277.104px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "85.9769px 277.104px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.73 303.26 6.63-3.79s3.18-17.52 0.8-32.58c-3.34-21.17-17.76-28.47-23-26.37s-6.46 8.38 3 20.61c5.57 7.22 12.75 22.48 12.57 42.13z",
    fill: "#ef4444",
    style: {
      transformOrigin: "92.0855px 271.717px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.73 303.26 6.63-3.79s3.18-17.52 0.8-32.58c-3.34-21.17-17.76-28.47-23-26.37s-6.46 8.38 3 20.61c5.57 7.22 12.75 22.48 12.57 42.13z",
    opacity: 0.3,
    style: {
      transformOrigin: "92.0855px 271.717px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.13,294.85h-.06a.49.49,0,0,1-.41-.54c2.74-19.82-5.23-41.54-14.19-50.29a.47.47,0,0,1,.66-.68c9.12,8.92,17.25,31,14.47,51.1A.47.47,0,0,1,100.13,294.85Z",
    fill: "#fff",
    style: {
      transformOrigin: "93.24px 269.028px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.34,313.88c-1,.6-3.21-.71-4-1.26A10,10,0,0,1,72,308.8a9.33,9.33,0,0,1-.83-5.63,22.38,22.38,0,0,1,.71-3l.84-2.9a7.37,7.37,0,0,0,.42-2.93c-.25-2-2-3.38-3.62-4.58-1.77-1.32-3.62-3.07-3.61-5.46a8.46,8.46,0,0,1,2.11-5c1.14-1.45,2.5-2.73,3.53-4.25a5.88,5.88,0,0,0,1.21-3.72,6.24,6.24,0,0,0-.81-2.32,31.94,31.94,0,0,1-2.54-4.66c-.58-1.67-.5-3.75.8-4.94a5.49,5.49,0,0,1,4.12-1,9.47,9.47,0,0,1,3.82,1.35c3.8,2.11,6,6.6,10,8.23A40.37,40.37,0,0,0,93,269.15a6,6,0,0,1,4,2.75c1.47,3-1.27,6.59-.23,9.73.92,2.77,3.62,3.83,5.13,6.33a6,6,0,0,1,.71,3.64,17.51,17.51,0,0,1-1.53,6.13,44.4,44.4,0,0,1-3.37,5.53C97.67,303.32,79.5,313.79,79.34,313.88Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "84.2821px 286.188px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.34,313.88c-1,.6-3.21-.71-4-1.26A10,10,0,0,1,72,308.8a9.33,9.33,0,0,1-.83-5.63,22.38,22.38,0,0,1,.71-3l.84-2.9a7.37,7.37,0,0,0,.42-2.93c-.25-2-2-3.38-3.62-4.58-1.77-1.32-3.62-3.07-3.61-5.46a8.46,8.46,0,0,1,2.11-5c1.14-1.45,2.5-2.73,3.53-4.25a5.88,5.88,0,0,0,1.21-3.72,6.24,6.24,0,0,0-.81-2.32,31.94,31.94,0,0,1-2.54-4.66c-.58-1.67-.5-3.75.8-4.94a5.49,5.49,0,0,1,4.12-1,9.47,9.47,0,0,1,3.82,1.35c3.8,2.11,6,6.6,10,8.23A40.37,40.37,0,0,0,93,269.15a6,6,0,0,1,4,2.75c1.47,3-1.27,6.59-.23,9.73.92,2.77,3.62,3.83,5.13,6.33a6,6,0,0,1,.71,3.64,17.51,17.51,0,0,1-1.53,6.13,44.4,44.4,0,0,1-3.37,5.53C97.67,303.32,79.5,313.79,79.34,313.88Z",
    opacity: 0.15,
    style: {
      transformOrigin: "84.2821px 286.188px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.1,308.15h0a.47.47,0,0,1-.46-.49c.78-18.76-8.06-39.48-14.49-45.5a.46.46,0,0,1,0-.66.47.47,0,0,1,.66,0c6.56,6.14,15.58,27.2,14.79,46.23A.47.47,0,0,1,90.1,308.15Z",
    fill: "#fff",
    style: {
      transformOrigin: "82.8295px 284.758px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.29,286a.32.32,0,0,1-.14,0,63.33,63.33,0,0,0-13.62-2.19.48.48,0,0,1,0-.95,65.16,65.16,0,0,1,13.86,2.24.47.47,0,0,1-.14.92Z",
    fill: "#fff",
    style: {
      transformOrigin: "80.4218px 284.44px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "139.022px 224.778px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "139.022px 224.778px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M160.58,132.9l-12.23-7.06c-.55-.31-.94-.39-1.16-.27l-1.49.87c-.26.14-.25.59.08,1.27l3,6.16-2.22,2a1.73,1.73,0,0,0,.33,2.94l12.22,7.06,1.5-.86Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "153.064px 135.693px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M160.58,132.9l-12.23-7.06c-.55-.31-.94-.39-1.16-.27l-1.49.87c-.26.14-.25.59.08,1.27l3,6.16-2.22,2a1.73,1.73,0,0,0,.33,2.94l12.22,7.06,1.5-.86Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "153.064px 135.693px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M146.86,126.71c-1.2-.7-1.68-.25-1.08,1l3,6.16-2.22,2a1.73,1.73,0,0,0,.33,2.94l12.22,7.06V133.76Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "152.316px 136.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.52 171.81a1.45 1.45 0 0 1-1.44-1.44v-40.62a1.44 1.44 0 0 1 2.88 0v40.62a1.45 1.45 0 0 1-1.44 1.44z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "160.52px 150.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m102.65 314.67v-2.54h0.62a10 10 0 0 1 4.11-4c6.32-3.65 16.56-3.65 22.88 0a10 10 0 0 1 4.11 4h0.63v2.46c0 2.43-1.52 4.86-4.73 6.72-6.32 3.64-16.56 3.64-22.88 0-3.18-1.83-4.76-4.24-4.74-6.64z",
    fill: "#263238",
    style: {
      transformOrigin: "118.825px 314.716px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 118.82,
    cy: 312.13,
    rx: 16.18,
    ry: 9.34,
    fill: "#455a64",
    style: {
      transformOrigin: "118.82px 312.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123,186.44V311a2.07,2.07,0,0,1-1.22,1.7,6.5,6.5,0,0,1-5.89,0,2.07,2.07,0,0,1-1.22-1.7V186.44Z",
    fill: "#37474f",
    style: {
      transformOrigin: "118.835px 249.923px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "114.66 196.95 114.66 205.12 122.99 209.92 122.99 201.77",
    fill: "#263238",
    style: {
      transformOrigin: "118.825px 203.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M150.11,181.7l15.4,8.9a1.11,1.11,0,0,1-.3.31l-26.94,15.55c-.23.13-.41,0-.41-.24V186.81a30.31,30.31,0,0,1,2.25-10.88Z",
    fill: "#37474f",
    style: {
      transformOrigin: "151.685px 191.221px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m165.63 169v21.72l-25.51-14.73a2 2 0 0 1 0.08-0.22c2.74-6.83 7.35-12.63 12.35-15.5a11.65 11.65 0 0 1 5.77-1.79c4.51-0.05 7.31 3.98 7.31 10.52z",
    fill: "#263238",
    style: {
      transformOrigin: "152.875px 174.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M193.34,214.92V213h-.18v.27a8.7,8.7,0,0,0-.51-1.57,14.65,14.65,0,0,0-6.44-6.54L168,194.61a3,3,0,0,0-2.75,0L137.36,210.7a3.85,3.85,0,0,1-.89-1v2h0a1,1,0,0,0,.57.8L155.27,223a34.86,34.86,0,0,0,17.44,4.12,30.32,30.32,0,0,0,14.51-3.53c4.1-2.36,6.12-5.48,6.12-8.67Z",
    fill: "#263238",
    style: {
      transformOrigin: "164.905px 210.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m192.65 211.68a14.65 14.65 0 0 0-6.44-6.54l-18.21-10.53a3 3 0 0 0-2.75 0l-27.89 16.09 17.91 10.35a34.86 34.86 0 0 0 17.44 4.12 30.32 30.32 0 0 0 14.51-3.53c3.68-2.12 5.69-4.85 6.06-7.7a8.32 8.32 0 0 0-0.63-2.26z",
    fill: "#455a64",
    style: {
      transformOrigin: "165.32px 209.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M193.28,213.94a8.32,8.32,0,0,0-.63-2.26,14.65,14.65,0,0,0-6.44-6.54L168,194.61a3,3,0,0,0-2.75,0L137.36,210.7l-.32-.18a.83.83,0,0,1,0-1.58l28.19-16.28a3,3,0,0,1,2.75,0l18.23,10.52c3.28,1.9,5.42,4.18,6.44,6.55a8.49,8.49,0,0,1,.65,2.4A7.82,7.82,0,0,1,193.28,213.94Z",
    fill: "#37474f",
    style: {
      transformOrigin: "164.904px 203.133px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "137.65 208.66 165.84 192.38 165.22 190.91 138.28 206.47",
    fill: "#455a64",
    style: {
      transformOrigin: "151.745px 199.785px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "144.255px 171.12px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M163.15,167.66a1.5,1.5,0,0,0-.67-1.17l-34.33-19.81a1.44,1.44,0,0,0-1.34,0l-.76.43a1.5,1.5,0,0,0-.67,1.16v26.32a1.5,1.5,0,0,0,.67,1.16l34.33,19.81a1.44,1.44,0,0,0,1.34,0l.76-.43a1.51,1.51,0,0,0,.67-1.16Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "144.265px 171.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M163,167l-1.9,1.1-35.47-20.48a1.42,1.42,0,0,1,.47-.5l.76-.43a1.44,1.44,0,0,1,1.34,0l34.32,19.81A1.44,1.44,0,0,1,163,167Z",
    opacity: 0.35,
    style: {
      transformOrigin: "144.315px 157.312px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.89 195.71z",
    fill: "#ef4444",
    style: {
      transformOrigin: "160.89px 195.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M161.05,168.09l-.35.21a.58.58,0,0,1,.35.57v26.31a.46.46,0,0,1-.21.44.44.44,0,0,1-.32,0l-.14-.06-34.33-19.82a1.5,1.5,0,0,1-.67-1.16V148.28a1.4,1.4,0,0,1,.2-.67Z",
    opacity: 0.2,
    style: {
      transformOrigin: "143.216px 171.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M161.05,168.09,145.15,174a2.6,2.6,0,0,1-3.07-1l-2.55-3.91-14.08-21.57L139,169.26l-13.64,5.34a1.49,1.49,0,0,0,.21.67l13.47-6,3,4.75a2.58,2.58,0,0,0,3.23,1l2.11-.93,13.47,21.49a.46.46,0,0,0,.21-.44v-.44L147.44,174.1Z",
    opacity: 0.2,
    style: {
      transformOrigin: "143.211px 171.55px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--letter--inject-5",
    className: "animable",
    style: {
      transformOrigin: "136.115px 175.775px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155,172.31a1.47,1.47,0,0,0-.67-1.16L120,151.33a1.53,1.53,0,0,0-1.35,0l-.75.44a1.47,1.47,0,0,0-.67,1.16v26.31a1.47,1.47,0,0,0,.67,1.16l34.32,19.82a1.5,1.5,0,0,0,1.34,0l.76-.44a1.47,1.47,0,0,0,.67-1.16Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "136.115px 175.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m154.83 171.65-1.91 1.1-35.47-20.48a1.44 1.44 0 0 1 0.48-0.5l0.76-0.44a1.5 1.5 0 0 1 1.34 0l34.32 19.82a1.36 1.36 0 0 1 0.48 0.5z",
    opacity: 0.35,
    style: {
      transformOrigin: "136.14px 161.961px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m152.77 200.37z",
    fill: "#ef4444",
    style: {
      transformOrigin: "152.77px 200.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M152.93,172.75l-.35.21a.58.58,0,0,1,.35.57v26.31a.46.46,0,0,1-.21.44.44.44,0,0,1-.32,0l-.14-.06-34.33-19.82a1.5,1.5,0,0,1-.67-1.16V152.94a1.4,1.4,0,0,1,.2-.67Z",
    opacity: 0.2,
    style: {
      transformOrigin: "135.096px 176.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M152.92,172.75,137,178.69a2.59,2.59,0,0,1-3.07-1l-2.55-3.91L117.33,152.2l13.57,21.71-13.64,5.34a1.32,1.32,0,0,0,.21.67L130.94,174l3,4.74a2.59,2.59,0,0,0,3.24,1l2.11-.94,13.47,21.5a.49.49,0,0,0,.2-.45v-.43l-13.6-20.64Z",
    opacity: 0.2,
    style: {
      transformOrigin: "135.111px 176.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--letter--inject-5",
    className: "animable",
    style: {
      transformOrigin: "128.015px 180.431px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M146.9,177a1.47,1.47,0,0,0-.67-1.16L111.9,156a1.47,1.47,0,0,0-1.34,0l-.76.44a1.47,1.47,0,0,0-.67,1.16V183.9a1.49,1.49,0,0,0,.67,1.16l34.33,19.82a1.5,1.5,0,0,0,1.34,0l.76-.44a1.49,1.49,0,0,0,.67-1.16Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "128.015px 180.438px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m146.7 176.31-1.9 1.1-35.47-20.48a1.34 1.34 0 0 1 0.47-0.5l0.76-0.44a1.44 1.44 0 0 1 1.34 0l34.33 19.82a1.34 1.34 0 0 1 0.47 0.5z",
    opacity: 0.35,
    style: {
      transformOrigin: "128.015px 166.617px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m144.64 205z",
    fill: "#ef4444",
    style: {
      transformOrigin: "144.64px 205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M144.8,177.4l-.35.21a.58.58,0,0,1,.35.57v26.31a.46.46,0,0,1-.21.44.44.44,0,0,1-.32,0l-.14-.06L109.8,185.06a1.5,1.5,0,0,1-.67-1.16V157.59a1.4,1.4,0,0,1,.2-.67Z",
    opacity: 0.2,
    style: {
      transformOrigin: "126.966px 180.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M144.8,177.41l-15.9,5.93a2.56,2.56,0,0,1-3.06-1l-2.56-3.92L109.2,156.85l13.57,21.72-13.64,5.34a1.54,1.54,0,0,0,.21.67l13.47-6,3,4.75a2.58,2.58,0,0,0,3.23,1l2.11-.93,13.47,21.49a.46.46,0,0,0,.21-.44v-.44l-13.61-20.64Z",
    opacity: 0.2,
    style: {
      transformOrigin: "126.981px 180.87px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M162.06,157.73c-2.73-1.43-6.35-1.18-10.31,1.11-4.45,2.56-8.46,7.19-11.27,12.51a39.18,39.18,0,0,0-1.76,3.78,31.9,31.9,0,0,0-2.45,11.68V209a2.89,2.89,0,0,1-1.37-.33L86.07,180.42A3.07,3.07,0,0,1,84.7,178V157c0-10.52,6.93-23,15.47-28,4-2.34,7.73-2.53,10.49-1v0Z",
    fill: "#455a64",
    style: {
      transformOrigin: "123.38px 168.007px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.72 175.13a31.9 31.9 0 0 0-2.45 11.68v22.19a2.73 2.73 0 0 1-0.5-0.05v-22.13c0-16.32 12.55-26.69 16-28-4.45 2.56-8.46 7.19-11.27 12.51a39.18 39.18 0 0 0-1.78 3.8z",
    fill: "#37474f",
    style: {
      transformOrigin: "143.77px 183.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.28,206.46c-.23.14-.42,0-.42-.23V186.81a30.28,30.28,0,0,1,2.26-10.87,2,2,0,0,1,.08-.22,36.4,36.4,0,0,1,1.88-4c2.74-5.06,6.48-9.22,10.47-11.51a11.65,11.65,0,0,1,5.77-1.79,6.38,6.38,0,0,1,3,.73c2.69,1.44,4.27,4.92,4.27,9.79v21.24a.9.9,0,0,1-.41.72l.62,1.47.14-.09a2.46,2.46,0,0,0,.57-.55h0a3,3,0,0,0,.66-1.74V169c0-5.63-2-9.55-5.15-11.21-2.74-1.44-6.35-1.19-10.32,1.1-4.44,2.56-8.45,7.19-11.27,12.51a39.09,39.09,0,0,0-1.75,3.78,31.9,31.9,0,0,0-2.45,11.68V209h.24a2.75,2.75,0,0,0,1.13-.32Z",
    fill: "#455a64",
    style: {
      transformOrigin: "151.7px 182.948px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a",
    className: "animable",
    style: {
      transformOrigin: "423.76px 321.988px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "423.76px 321.988px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m458.17 294.35h-68.83l6 60.78c0.37 3.89 3.13 7.72 8.28 10.69 11.11 6.42 29.11 6.42 40.22 0 5.15-3 7.9-6.8 8.28-10.69z",
    fill: "#37474f",
    style: {
      transformOrigin: "423.755px 332.493px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 423.76,
    cy: 293.24,
    rx: 34.47,
    ry: 19.9,
    fill: "#455a64",
    style: {
      transformOrigin: "423.76px 293.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m423.76 310.3c-8.72 0-16.87-1.93-23-5.44-5.59-3.23-8.67-7.36-8.67-11.62s3.08-8.39 8.67-11.62c6.09-3.51 14.24-5.45 23-5.45s16.87 1.94 22.95 5.45c5.6 3.23 8.68 7.36 8.68 11.62s-3.08 8.39-8.68 11.62c-6.08 3.51-14.23 5.44-22.95 5.44z",
    fill: "#37474f",
    style: {
      transformOrigin: "423.74px 293.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M447.42,297.27c-1.72-1.29-4.78-.12-6-1.92-.38-.57-.45-1.34-1-1.78-1.6-1.32-4,2.26-5.7,1-.62-.45-.78-1.41-1.47-1.72-.51-.22-1.09,0-1.64,0a3.3,3.3,0,0,1-2.58-2.22,11.6,11.6,0,0,0-1.59-3.21,3.54,3.54,0,0,0-2.29-1.13c-2.16-.19-3.93,1.57-5.38,3.18-.23.26-.47.52-.7.79a5.2,5.2,0,0,1-1.49,1.28,1.33,1.33,0,0,1-1,.14,1.43,1.43,0,0,1-.79-.81c-.61-1.32-.47-3.35-1.88-3.72-.38-.1-.83-.05-1.13-.31s-.29-.65-.5-.94a1.55,1.55,0,0,0-1.19-.5c-2.9-.22-5.46,1.73-7.71,3.57-1.21-.8-1.34-2.57-.88-4,1.16-3.46,4.81-5.37,8.23-6.65,1.6-.6,3.23-1.13,4.87-1.61a42,42,0,0,0-14.89,4.85c-5.59,3.23-8.67,7.36-8.67,11.62s3.08,8.39,8.67,11.62c6.09,3.51,14.24,5.44,23,5.44s16.87-1.93,22.95-5.44l.36-.22c.34-.71.65-1.43.92-2.17C448.63,300.71,448.91,298.4,447.42,297.27Z",
    opacity: 0.1,
    style: {
      transformOrigin: "420.27px 293.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.56,361.4a31,31,0,0,1-4.38-2.08c-.52-.3-1-.6-1.48-.92a5.21,5.21,0,0,1-1.61-3.51L396.68,314c-.12-1.37.5-1.91,1.44-1.28q.83.56,1.74,1.08a35.73,35.73,0,0,0,5.44,2.55,4.07,4.07,0,0,1,2.49,3.31l2,40.05A1.56,1.56,0,0,1,407.56,361.4Z",
    fill: "#263238",
    style: {
      transformOrigin: "403.242px 337.012px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.06,321.77l-.68,39.76a2.74,2.74,0,0,1-2.54,2.67c-1.38.06-2.78.06-4.17,0a2.74,2.74,0,0,1-2.53-2.67l-.65-39.76a2.26,2.26,0,0,1,2.45-2.32,53.62,53.62,0,0,0,5.67,0A2.26,2.26,0,0,1,429.06,321.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "423.775px 341.843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M450.89,314l-3.45,40.92a5.31,5.31,0,0,1-1.62,3.52c-.47.31-1,.62-1.48.91A31.66,31.66,0,0,1,440,361.4a1.56,1.56,0,0,1-2.24-1.68l2-40.06a4.07,4.07,0,0,1,2.49-3.31,36.92,36.92,0,0,0,5.42-2.54c.61-.35,1.2-.72,1.76-1.1C450.37,312.07,451,312.6,450.89,314Z",
    fill: "#263238",
    style: {
      transformOrigin: "444.318px 337.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.11,299.06a20.48,20.48,0,0,0,6.69,5.8c6.09,3.51,14.24,5.44,23,5.44s16.87-1.93,22.95-5.44a23.78,23.78,0,0,0,4.88-3.65,6.13,6.13,0,0,0-.61-1.71,4,4,0,0,0-3.1-2.12c-.75,0-1.49.17-2.23.13a1.74,1.74,0,0,1-1.72-1.15c-.07-.33,0-.68-.05-1-.17-.87-1.27-1.24-2.15-1.08s-1.65.67-2.51.89a1.94,1.94,0,0,1-2.31-.8c-.17-.42-.11-.92-.35-1.31-.48-.81-1.9-.63-2.37-1.45-.37-.65.09-1.43.2-2.16a3.11,3.11,0,0,0-1.77-3,9,9,0,0,0-3.58-.8,5.9,5.9,0,0,0-3.9.55c-1.16.8-1.59,2.27-2.14,3.56s-1.57,2.64-3,2.63a3.22,3.22,0,0,0-1.89-2.73,13.09,13.09,0,0,0-2-.5c-2.05-.56-4-2.27-6-1.72a5.8,5.8,0,0,0-2.24,1.43l-3.34,2.93a5.38,5.38,0,0,0-1.82,2.34,4.9,4.9,0,0,1-.36,1.2c-.63,1-1.94.6-2.91.62a5.43,5.43,0,0,0-3.7,1.12A6.15,6.15,0,0,0,394.11,299.06Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "422.87px 297.916px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M446.71,304.86a23.78,23.78,0,0,0,4.88-3.65,6.09,6.09,0,0,0-.17-.61,9.89,9.89,0,0,1-8.5,2,10.38,10.38,0,0,0-3-.6,2.15,2.15,0,0,0-2.17,1.81.8.8,0,0,1,0,.41.59.59,0,0,1-.43.24c-2.62.57-5.6-1-7.92.37a14.26,14.26,0,0,1-2.4,1.59,4.8,4.8,0,0,1-3.07-.42,1.93,1.93,0,0,1-.77-.42c-.4-.41-.39-1.06-.7-1.53a2.71,2.71,0,0,0-1.05-.77,8.22,8.22,0,0,0-4.49-1.24,5.5,5.5,0,0,0-4.17,3.55c-3.69-1.29-6.36-5.6-10.25-5.19-.34-1.2,1.09-2.11,2.29-2.47s2.69-.92,2.74-2.17c0-.52-.24-1-.18-1.54.09-.72.81-1.36.59-2.06a3.1,3.1,0,0,0-.59-.82,2.14,2.14,0,0,1-.38-1.59l-2.29,2a5.38,5.38,0,0,0-1.82,2.34,4.9,4.9,0,0,1-.36,1.2c-.63,1-1.94.6-2.91.62a5.43,5.43,0,0,0-3.7,1.12,6.15,6.15,0,0,0-1.69,2,20.48,20.48,0,0,0,6.69,5.8c6.09,3.51,14.24,5.44,23,5.44S440.63,308.37,446.71,304.86Z",
    opacity: 0.1,
    style: {
      transformOrigin: "422.895px 300.01px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "314.355px 229.816px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "314.355px 229.816px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    className: "animable",
    style: {
      transformOrigin: "378.905px 230.072px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.74,226.81a1.39,1.39,0,0,0-.63-1.1L363.69,207a1.42,1.42,0,0,0-1.27,0l-.71.42a1.4,1.4,0,0,0-.64,1.09v24.85a1.4,1.4,0,0,0,.64,1.1l32.42,18.72a1.4,1.4,0,0,0,1.26,0l.72-.42a1.39,1.39,0,0,0,.63-1.09Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "378.905px 230.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m396.56 226.18-1.8 1-33.5-19.34a1.3 1.3 0 0 1 0.45-0.48l0.71-0.41a1.42 1.42 0 0 1 1.27 0l32.42 18.72a1.45 1.45 0 0 1 0.45 0.51z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "378.91px 216.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.74,226.81v24.85a1.39,1.39,0,0,1-.63,1.09l-.72.42-.17.08-.26.06a1.68,1.68,0,0,1-.5,0l-.12,0a.13.13,0,0,1-.08,0,.35.35,0,0,0,.3,0,.44.44,0,0,0,.2-.42V228a.55.55,0,0,0-.33-.54l.33-.19,1.8-1A1.37,1.37,0,0,1,396.74,226.81Z",
    opacity: 0.2,
    style: {
      transformOrigin: "395.5px 239.807px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.76,227.22l-15,5.61a2.45,2.45,0,0,1-2.9-1l-2.41-3.7-13.3-20.37L374,228.32l-12.89,5a1.41,1.41,0,0,0,.2.64L374,228.38l2.81,4.48a2.43,2.43,0,0,0,3.05.94l2-.88,12.71,20.3a.44.44,0,0,0,.2-.42v-.41l-12.85-19.5Z",
    opacity: 0.2,
    style: {
      transformOrigin: "377.941px 230.49px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M367.09,179.57l-14.87-26.84s-16.53-20.64-10.06-29.2c8.82-.81,16.62.73,24,15,8.29,15.91,12.23,27.43,16.54,37.8,1.19,2.87,1.07,17,.79,27.69-.18,7,.24,14.59.24,14.59l-5.6-3.23a8.65,8.65,0,0,0-4.21-1.16h-1.4a12.84,12.84,0,0,0-3,5.13c-.89,4-3.08,5.24-4.26,4.3-.57-.46-1-2.82.33-8.42,1.08-4.6,5.27-9.1,4.72-12.62Z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "362.194px 173.652px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M342.16,123.53s5.62-1.26,9.84.16,7.18,3.07,11.69,9.79,14.51,30.18,14.51,30.18-1.21,6.46-16,8.78l-14.74-23.73Z",
    fill: "#37474f",
    style: {
      transformOrigin: "360.18px 147.727px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "319.11 116.05 322.08 134.78 340.66 133.79 338 112.01",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "329.885px 123.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m306.62 93.05s-4.43 6.72-3.92 7.38 3.76 1.26 3.76 1.26z",
    fill: "#f28f8f",
    style: {
      transformOrigin: "304.64px 97.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.92 74.47c-9 1.89-11.55 5.83-12.4 20.06-0.88 14.87 0.64 19.55 2.59 21.55 1.32 1.35 8.65 1.6 12.35 0.58 4.63-1.28 15.09-5 20-12.47 5.76-8.8 7.27-20.73 1.1-25.62-8.69-6.89-20-4.87-23.64-4.1z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "326.4px 95.4384px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m319.28 117.07a37.3 37.3 0 0 0 4.72-1.19 8.37 8.37 0 0 1-4.5 2.6z",
    fill: "#f28f8f",
    style: {
      transformOrigin: "321.64px 117.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m304.71 80a12.59 12.59 0 0 0 2.29 1.78 31.71 31.71 0 0 0 3.74 2.07 21.6 21.6 0 0 1 3.64 1.71c1.63 1.16 1.84 2.69 1.88 4.56v4.39c0 2.47 1.6 4.34 2.37 1 0 0 1.42-5.49 6.05-4.8s5 5.91 2.84 10c-1.35 2.49-4.95 1.84-4.95 1.84a16.21 16.21 0 0 0 4.84 12.47s3.57 1.08 10.86-0.47c4.48-1 8.78-5.89 11.44-11.82 5.63-12.54 6-23.83-2-27.21-0.87-5.78-5.42-8.37-10.6-9.56-7.76-1.78-15 2.82-22.69 1.11a36.74 36.74 0 0 1-3.74-1 2.09 2.09 0 0 0-1.51-0.1 1.71 1.71 0 0 0-0.73 1.71 4.64 4.64 0 0 0 2.26 3.64c-0.16-0.09-0.91 0.11-1.11 0.12-0.43 0-0.86 0-1.29 0.05a23.53 23.53 0 0 1-2.52-0.18 4.62 4.62 0 0 0-1.74 0.06 3.14 3.14 0 0 0-2 3.16 7.75 7.75 0 0 0 1.38 3.72 11.3 11.3 0 0 0 0.93 1.33c0.16 0.17 0.26 0.28 0.36 0.42z",
    fill: "#263238",
    style: {
      transformOrigin: "327.936px 90.4645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m347.91 77.5 5.36-3.16a3.11 3.11 0 0 0-5.36 3.16z",
    fill: "#263238",
    style: {
      transformOrigin: "350.374px 75.1545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M352.91,355.79,353,357a21.85,21.85,0,0,1,.12,4.78c-.13,1.1-.45,2.59-1.47,3.19a12.88,12.88,0,0,1-3.5,1.37,12.25,12.25,0,0,1-8.11-.8c-2.1-1-3.75-2.62-6-3.26a45.32,45.32,0,0,0-7.16-1.18,16.14,16.14,0,0,1-3.16-.58,15,15,0,0,1-2.28-1,22.46,22.46,0,0,1-6.77-4.94,10.72,10.72,0,0,1-2.41-4.83c-.21-1.05-.64-4.09,1.12-4,8.62.39,17.15,2.24,25.78,2.14a9.45,9.45,0,0,1,1.68.07,7,7,0,0,1,2.89,1.35,3,3,0,0,0,2.65.65,13.16,13.16,0,0,1,4.47.06,2.11,2.11,0,0,1,1.54,1,2.35,2.35,0,0,1,.13.65C352.64,353,352.78,354.41,352.91,355.79Z",
    fill: "#263238",
    style: {
      transformOrigin: "332.627px 356.221px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M352,345.46l-.44,6.5c-.42,2.47-8.85,4-10.59-.39l-.83-7.37Z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "346.07px 349.277px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320,371.16s1,3.38,1.56,6.33c.42,2.34,1,6.25.16,8s-4.07,2.8-9,2.65c-3.2-.1-8.23,2-11.69,3.79s-10.92,2.51-14.64,2c-4.39-.62-8.88-3.27-9.55-5.11s.32-3.7,10.77-7.88c.1,0,14.51-4.37,19.65-9.79Z",
    fill: "#263238",
    style: {
      transformOrigin: "299.413px 382.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320.05,367s-.08,2.86-.11,4.5-2,4-7,3.74c-3.51-.21-5.94-1.21-5.73-4.1l.09-4.17Z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "313.624px 371.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M355.43,295.56c-1.48-12.65-2.59-19.89-2.59-19.89s.25-17.61,1.29-34c1.11-17.74.86-40.08,1.3-44.5,0,0-57-12.17-57.46,8.38-.54,23.88,1,73.29,1.39,79.72.48,9,.5,18.43,2,33.08,1.51,14.47,5.9,48.65,5.9,48.65,6.47,3.69,12.76,0,12.76,0s4.95-41,4.76-51.37a142.77,142.77,0,0,0-2.16-22.52l4.49-46.35s1.76,14.33,2.24,23.36,1.71,14.55,3.94,31.35c1.94,14.59,6.85,45.36,6.85,45.36a11.52,11.52,0,0,0,12.12-.48S356.91,308.21,355.43,295.56Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "326.789px 281.116px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m348.82 225.19s-3.95 6.51-15.93 11.29l-3.34 11.19-0.36 19.67c-0.46-6.34-1.16-13.26-2.05-20.59l1.35-11.53s13.23-4.01 20.33-10.03z",
    opacity: 0.15,
    style: {
      transformOrigin: "337.98px 246.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m357.62 135.52c-2.29-8.14-7.66-11.74-13.63-12.12-1.52-0.1-4.6 0-4.6 0 0.42 3.45-10.21 5.89-18.48 3.94-2.49 0.66-6.62 1.59-8.7 2.28-5.94 2-13.07 9.41-14 28.8 0 0-0.94 41.67-0.65 53.77 14.68 6.2 28.85 7 37.4 5.3 17.81-3.47 20.74-11.1 20.74-11.1s-0.17-10.59-0.83-27.48c3.02-23.98 3.74-39.85 2.75-43.39z",
    fill: "#455a64",
    style: {
      transformOrigin: "327.77px 170.812px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "257.942px 128.995px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M233.07,124.26a.77.77,0,0,1,.45-1l36.34-14.62a2.69,2.69,0,0,1,1.68.12l1.1.46a2.43,2.43,0,0,1,1.23,1.09l8.93,23.42a.76.76,0,0,1-.45,1L246,149.35a2.69,2.69,0,0,1-1.68-.12l-1.1-.46a2.46,2.46,0,0,1-1.24-1.09Z",
    fill: "#ef4444",
    style: {
      transformOrigin: "257.937px 128.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M233.09,123.69l2.77,1.15,37.54-15.11a3,3,0,0,0-.76-.48l-1.1-.46a2.62,2.62,0,0,0-1.68-.12l-36.34,14.62A.81.81,0,0,0,233.09,123.69Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "253.245px 116.712px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M233.07,124.26,242,147.68a2.46,2.46,0,0,0,1.24,1.09l1.1.46.26.09.36.08a3.77,3.77,0,0,0,.66,0l.15,0,.09,0a.68.68,0,0,1-.4,0,.69.69,0,0,1-.41-.41l-8.93-23.41a.33.33,0,0,1,.24-.48l-.5-.21-2.77-1.15A.75.75,0,0,0,233.07,124.26Z",
    opacity: 0.2,
    style: {
      transformOrigin: "239.446px 136.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M235.86,124.84l21.95,6.68c1.57.48,3,.22,3.51-.63l1.87-3.25,10.34-18-9.65,18.13,18.93,6a.75.75,0,0,1,0,.57l-18.92-6.48-2.11,4c-.48.91-2.07,1.16-3.72.6l-3-1-9.6,17.94a.69.69,0,0,1-.41-.41l-.15-.39L255,131.38Z",
    opacity: 0.2,
    style: {
      transformOrigin: "259.363px 129.52px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294.9,143.25c-6.75,8.66-16.2,20.84-21.54,28.06-3.84-3.69-17.83-16.91-19.27-19-1.61-2.32-1.54-5.5-2.87-8.9-1.08-2.78-3.52-6.21-4.15-7.63-1.15-2.6-3.68-3.89-3.72-.09,0,3.16,1.5,6.92,1.33,7.64-.08.31-1.33-.32-2.69-1.6a12.65,12.65,0,0,1-1.62-1.88L237.53,136l-2-5.15s-.79.11-1.79,2.49c-2.88,6.86-2.5,14.37,3.05,20.42,3.29,3.59,8.83,8.5,14.58,15.4S267.9,188,272.5,190.65c4.14,2.38,9.19-1.38,15-7.26,8.15-8.21,20.75-22,20.75-22s9.4-15.94,3.92-31.77C305.3,129.88,303.52,132.2,294.9,143.25Z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "272.928px 160.497px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M314.42,129s-6.63.43-10.85,2.58c-1.13.58-4.37,4.1-7.45,8.22-6,8.09-16.59,22.11-16.59,22.11s.2,13.29,13.23,17c0,0,13.05-13.39,16.56-17.53C313.89,156,318.35,140,314.42,129Z",
    fill: "#37474f",
    style: {
      transformOrigin: "297.731px 153.955px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxCleanup);
export default __webpack_public_path__ + "static/media/inbox_cleanup.713ab80383d505e6bb8503a679e45cc9.svg";
export { ForwardRef as ReactComponent };